import React from "react";
import FormField from "../components/FormField";
import PlateField from "../components/PlateField";

export default function Step2VehicleInfo({ data, onChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">اطلاعات خودرو</h2>

      <p className="mt-1 text-sm text-gray-500">
        مشخصات فنی و هویتی خودرویی که قصد فروش آن را دارید وارد کنید.
      </p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          label="نام دستگاه"
          name="vehicleName"
          value={data.vehicleName}
          onChange={onChange}
          placeholder="مثلاً پژو ۲۰۷"
          required
        />

        <FormField
          label="مدل دستگاه"
          name="vehicleModel"
          value={data.vehicleModel}
          onChange={onChange}
          placeholder="مثلاً ۱۴۰۲"
          required
        />

        <FormField
          label="رنگ دستگاه"
          name="vehicleColor"
          value={data.vehicleColor}
          onChange={onChange}
          placeholder="مثلاً سفید"
          required
        />

        <PlateField value={data.plateNumber} onChange={onChange} />

        <FormField
          label="شماره شاسی"
          name="chassisNumber"
          value={data.chassisNumber}
          onChange={onChange}
          placeholder="شماره شاسی خودرو"
          required
        />

        <FormField
          label="شماره موتور"
          name="engineNumber"
          value={data.engineNumber}
          onChange={onChange}
          placeholder="شماره موتور خودرو"
          required
        />
      </div>
    </div>
  );
}
